import { render, staticRenderFns } from "./DSCheckbox.vue?vue&type=template&id=31bdefb7&scoped=true&"
import script from "./DSCheckbox.vue?vue&type=script&lang=js&"
export * from "./DSCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bdefb7",
  null
  
)

export default component.exports